import { ApplicationConfig, ENV } from "../types";


export const config: ApplicationConfig = {
  API_BASE_URL: "https://api.orchestration.test.unlikely.ai/api/v1",
  PRODUCT_RECOMMENDATION_API_BASE_URL:
    "https://api.product-rec.test.unlikely.ai/api/v1",
  INGESTION_SERVICE_API_BASE_URL:
    "https://api.ingestion.test.unlikely.ai/api/v1",
  UNCHECK_SERVICE_API_BASE_URL: "https://api.uncheck.test.unlikely.ai/api/v1",
  ENV: ENV.TEST,
  AUTH0: {
    AUDIENCE: "https://api.test.unlikely.ai",
    CLIENT_ID: "iOomJ5lLBGZMITepbD35u9gdEygrsgBP",
    DOMAIN: "unlikelyai-test.uk.auth0.com",
  },
  UNCHECK_ORGANISATION_ID: "org_Vm7VUrqJJRHo4XrG",
};
